import {connect} from 'utils/reduxUtils';
import {Selectors as CompaniesSelectors} from 'modules/companies';
import {Selectors as JobsSelectors} from 'modules/companyJobs';
import CompanyRoute from './CompanyRoute';
import {Actions} from './companyRouteActions';
import {Selectors as I18nSelectors} from 'modules/i18n';
import {Selectors as ReferrerSelectors} from 'modules/referrer';
import {Selectors as NavigationSelectors} from 'modules/navigation';

const mapStateToProps = state => {
    return {
        company: CompaniesSelectors.matchingCompanySelector(state),
        job: JobsSelectors.matchingJobSelector(state),
        loading: CompaniesSelectors.isFetchingDataSelector(state),
        locale: I18nSelectors.localeSelector(state),
        referrer: ReferrerSelectors.matchingReferrerOwnLinkSelector(state),
        path: NavigationSelectors.pathnameSelector(state)
    };
}

const mapDispatchToProps = {
    onMount: Actions.PUBLIC_COMPANY_ROUTE_MOUNTING,
}

export default connect(mapStateToProps, mapDispatchToProps)(CompanyRoute);
